import React, { Fragment,useState, useEffect } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import estilos from './VisitasListComponent.module.css'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faAngleLeft, faAngleRight, faCalendar, faPenToSquare, faTrash, faPerson, faComments
} from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import ChatComponent from './ChatComponent';


library.add(faAngleLeft, faAngleRight, faPenToSquare, faTrash, faPerson, faComments)


const VisitasListItemComponent = (props) => {

    const instalacion = props.instalacion

    const [openReagendar, setOpenReagendar] = React.useState(false);
    const handleOpenReagendar = () => setOpenReagendar(true);
    const handleCloseReagendar = () => setOpenReagendar(false);

    const [openCambiarInspector, setOpenCambiarInspector] = React.useState(false);
    const handleOpenCambiarInspector = () => setOpenCambiarInspector(true);
    const handleCloseCambiarInspector = () => setOpenCambiarInspector(false);

    const [openEjemplo, setOpenEjemplo] = React.useState(false);
    const handleOpenEjemplo = () => setOpenEjemplo(true);
    const handleCloseEjemplo = () => setOpenEjemplo(false);

    const [openChat, setOpenChat] = React.useState(false);
    const handleOpenChat = () => setOpenChat(true);
    const handleCloseChat = () => setOpenChat(false);

    const alertTypeArray =['alert-primary','alert-secondary','alert-success','alert-danger','alert-warning','alert-info'];
    const [age, setAge] = React.useState('');
    const [alertType, setAlertType] = React.useState('');


    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiempre','Octubre','Noviembre','Diciembre'];

    useEffect(() => {
        {
            instalacion.solicitudes.map((s) => {
              if (s.estado === 1){
                setAlertType(alertTypeArray[0]);
              }
              else if (s.estado === 2){
                setAlertType(alertTypeArray[1]);
              } else if (s.estado === 3) {
                setAlertType(alertTypeArray[2]);
              }
              
            })
        }
             
      });
    


    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 1200, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, textAlign: 'center'
    };


    const modalChat = () => {
        return (
            <Modal  key={instalacion.id} sx={{ backgroundColor: 'transparent' }}
                open={openChat}
                hideBackdrop={true}
                onClose={handleCloseChat}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}  key={instalacion.id}>

                    <ChatComponent key={instalacion.id}></ChatComponent>
                    <button onClick={handleCloseChat} className='btn btn-outline-secondary'> X</button>

                </Box>
            </Modal>
        )
    }

    const modalReagendar = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openReagendar}
                        onClose={handleCloseReagendar}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}  key={instalacion.id}>
                            <Typography id="modal-modal-title" variant="h4" component="h2">
                                Seleccione la fecha propuesta para esta visita
                            </Typography>
                            <br /><br /><br />

                            <div className='row'>
                                <div className='col-2'>
                                </div>

                                <div className='col-8'>
                                    <input type='date' className='form-control' />
                                </div>
                                <div className='col-2'>
                                </div>
                            </div>
                            <br></br>
                            <button onClick={handleCloseReagendar} className='btn btn-success'> Reagendar</button>

                        </Box>
                    </Modal>
                }
            </Fragment>

        )
    }

    const modalCambiarInspector = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openCambiarInspector}
                        onClose={handleCloseCambiarInspector}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}  key={instalacion.id}>
                            <Typography id="modal-modal-title" variant="h4" component="h2">
                                Seleccione al inspector que desea cambiar
                            </Typography>
                            <br /><br /><br />
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Inspector</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Inspector"
                                    value={age}
                                    onChange={handleChange}
                                >

                                    <MenuItem value={1}>Jose Alfredo Cruz Velásco</MenuItem>
                                    <MenuItem value={2}>Uziel</MenuItem>
                                    <MenuItem value={3}>Elionai</MenuItem>
                                </Select>
                            </FormControl>

                            <br></br><br></br>
                            <button onClick={handleCloseCambiarInspector} className='btn btn-success'> Reagendar</button>
                        </Box>
                    </Modal>
                }
            </Fragment>
        )
    }
    const modalEjemplo = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openEjemplo}
                        onClose={handleCloseEjemplo}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}  key={instalacion.id}>

                            <Typography id="modal-modal-title" variant="h4" component="h2">
                                Ver solicitud / dictámen / plan de evaluación / informe
                            </Typography>
                            <br /><br /><br />
                        </Box>
                    </Modal>
                }
            </Fragment>
        )
    }


    /*
    si no ha pasado el inspector: pendiente inspeccion.
    si ya paso el inspector: informe emitido.
    si esta en proceso de revision del informe: informe en revisión.
    Si ya lo reviso el gerente: dictamen emitido.
    cuando se finalize todo el proceso: Solictud atendida
    */

    return (
        <Fragment>
            {
                instalacion.solicitudes.map((solicitud, index) => (
                    <div scope="row" className={`${estilos.zoom}`} key={index}>
                    <div className={`alert ${alertTypeArray[solicitud.estado]} ${estilos.alertItem}`} role="alert">
                        <div className='row'>
                            <div className='col-md-2'>
                                <h1>{solicitud.fecha}</h1>
                                <h4>{solicitud.dia} de {meses[solicitud.mes-1]} del {solicitud.anio}</h4><br></br><br></br>
                                <h4><i><strong></strong></i></h4>
                                <h5><strong>ID:</strong> {solicitud.id}</h5>
                            </div>
                            <div className='col-md-8' style={{ textAlign: 'justify' }}>
                                <div className='row'>
                                    <div className='col-6'>
                                        <h2><strong>{solicitud.nombreSolicitud}</strong></h2>
                                    </div>
                                    <div className='col-6'>
                                        <h5>Asignado a: <strong>
                                            <br></br>{solicitud.inspector}</strong> el 01/01/2022</h5>
                                    </div>
                                </div>
                                <br></br>
                                <div className='row'>
                                    <div className='col-3'>
                                        <button onClick={handleOpenEjemplo} className='btn btn-outline-secondary'>Ver solicitud</button>
                                    </div>
    
                                    <div className='col-3'>
                                        <button onClick={handleOpenEjemplo} className='btn btn-outline-secondary'>Ver informe</button>
                                    </div>
                                    <div className='col-3'>
                                        <button onClick={handleOpenEjemplo} className='btn btn-outline-secondary'>ver dictámen</button>
                                    </div>
                                </div>
    
    
                            </div>
                            <div className='col-md-2'>
                                <div className={`${estilos.buttons}`}>
    
                                    <button onClick={handleOpenCambiarInspector} className='btn btn-primary text-light btn-block'><FontAwesomeIcon icon={faPerson} /><br />Reasignar Inspector</button>
                                    <button onClick={handleOpenReagendar} className='btn btn-success text-light btn-block'><FontAwesomeIcon icon={faCalendar} /><br />Reagendar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ))
                
            }
            {modalEjemplo()}
            {modalCambiarInspector()}
            {modalReagendar()}
            {modalChat()}


        </Fragment>

    )
}

export default VisitasListItemComponent